export const LEASING_WITH_VAT_PARAM_NAME = 'leasing-with-vat'
export const LEASING_DURATION_PARAM_NAME = 'leasing-duration'
export const LEASING_MILEAGE_PARAM_NAME = 'leasing-mileage'
export const LEASING_DOWNPAYMENT_PARAM_NAME = 'leasing-downpayment'
export const LEASING_LEASE_PARAM_NAME = 'leasing-lease'
